module.exports = __webpack_public_path__ + "img/fork_red.58be9b77.svg";